import { Boxes, CheckCircle2, AlertTriangle, XOctagon } from "lucide-react";

export const KpiCards = ({ categories }) => {
  const withK = categories.filter((c) => c.has_kondisi);
  const sum = (k) => withK.reduce((a, c) => a + c.kondisi[k], 0);
  const total = categories.reduce((a, c) => a + c.total, 0);
  const cards = [
    { id: "total", label: "Total Entri Data", value: total, icon: Boxes, color: "#38bdf8" },
    { id: "baik", label: "Kondisi Baik", value: sum("BAIK"), icon: CheckCircle2, color: "#34d399" },
    { id: "rusak-ringan", label: "Rusak Ringan", value: sum("RUSAK RINGAN"), icon: AlertTriangle, color: "#fbbf24" },
    { id: "rusak-berat", label: "Rusak Berat", value: sum("RUSAK BERAT"), icon: XOctagon, color: "#fb7185" },
  ];
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
      {cards.map((c, i) => (
        <div key={c.id} data-testid={`kpi-${c.id}`} style={{ animationDelay: `${120 + i * 70}ms` }}
          className="fade-up group relative border border-[#1e40af]/70 bg-[#0b1736]/60 backdrop-blur-md p-4 sm:p-5 transition-colors hover:border-[#38bdf8]/70">
          <div className="absolute left-0 top-0 h-full w-[2px]" style={{ background: c.color, boxShadow: `0 0 12px ${c.color}` }} />
          <div className="flex items-center justify-between">
            <span className="text-[10px] sm:text-[11px] font-mono uppercase tracking-[0.18em] text-[#93c5fd]">{c.label}</span>
            <c.icon className="h-4 w-4" style={{ color: c.color }} />
          </div>
          <div className="mt-3 font-heading font-black text-3xl sm:text-4xl tabular-nums" style={{ color: c.color, textShadow: `0 0 18px ${c.color}55` }}>
            {c.value.toLocaleString("id-ID")}
          </div>
          {c.id !== "total" && total > 0 && (
            <div className="mt-3 h-1 bg-[#1e3a8a]/60 overflow-hidden">
              <div className="h-full transition-[width] duration-700" style={{ width: `${(c.value / total) * 100}%`, background: c.color }} />
            </div>
          )}
        </div>
      ))}
    </div>
  );
};
